import { Component, Input, OnInit, Type } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BookmarkService } from 'src/app/components/bookmarks/bookmark.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { BookmarkType } from '../bookmarks';
import { BookmarksLabelDialogComponent } from '../bookmarks-label-dialog/bookmarks-label-dialog.component';

export type AskForLabelOption = 'IfEmpty' | 'Always' | 'Never';

@Component({
    selector: 'app-bookmark-btn',
    templateUrl: './bookmark-btn.component.html',
    styleUrls: ['./bookmark-btn.component.scss'],
    standalone: false
})
export class BookmarkBtnComponent implements OnInit {

  private invalidSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public invalid$: Observable<boolean> = this.invalidSubject.asObservable();

  private _askForLabel: AskForLabelOption = 'IfEmpty';
  @Input() set askForLabel(option: AskForLabelOption) {
    this._askForLabel = option;
  }

  private _label: string;
  @Input() set label(label: string) {
    this._label = label;
  }

  private _labelRequired: boolean = false;
  @Input() set labelRequired(required: boolean) {
    this._labelRequired = required;
  }

  private _itemType: BookmarkType;
  @Input() set itemType(type: BookmarkType) {
    this._itemType = type;
    this.updateValid();
  }

  private _itemId: string;
  @Input() set itemId(id: string) {
    this._itemId = id;
    this.updateValid();
  }

  constructor(private bookmarkService: BookmarkService, private dialog: MatDialog) { }

  ngOnInit(): void {
    this.updateValid();
  }

  public btnClick() {
    if (this.showDialog()) {
      this.dialog.open(
        BookmarksLabelDialogComponent,
        {
          disableClose: true,
          autoFocus: false,
          position: { top: '100px' },
          width: '250px',
          data:
          {
            title: 'Bookmark label',
            text: `Provide a label to easier find your bookmark`,
            okText: 'Save',
            cancelText: 'Cancel',
            label: this._label,
            labelRequired: false,
          }
        }
      ).afterClosed().subscribe(result => {
        this._label = result;
        this.addBookmark();
      });

    } else {
      this.addBookmark();
    }
  }

  private addBookmark() {
    this.bookmarkService.addBookmark({ type: this._itemType, id: this._itemId, label: this._label });
  }

  private showDialog(): boolean {
    return this._askForLabel === 'Always' || (!this._label && this._askForLabel === 'IfEmpty');
  }

  private updateValid() {
    this.invalidSubject.next((!this._itemId || !this._itemType || (this._labelRequired && !this._label)));
  }
}
